import { HttpClinet, baseURL, version } from './../utils/config'

export const gmAPI = {
    getOrgUnitName: () => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/groupmail/getOrgUnitName`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },

}